
import { defineComponent } from 'vue'
import { AxiosResponse } from 'axios'
import Checkbox from 'primevue/checkbox'
import Dialog from 'primevue/dialog'
import InputSwitch from 'primevue/inputswitch'
import generateDatamartCardDescriptor from './GenerateDatamartCardDescriptor.json'

export default defineComponent({
    name: 'generate-datamart-card',
    components: {
        Checkbox,
        Dialog,
        InputSwitch
    },
    props: {
        businessModel: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            required: true
        }
    },
    emits: ['generated', 'close'],
    watch: {
        businessModel() {
            this.loadBusinessModel()
        }
    },
    async created() {
        this.loadBusinessModel()
        this.loadUser()
        await this.loadModelInfo()
    },
    data() {
        return {
            generateDatamartCardDescriptor,
            showAdvancedOptions: false,
            model: {},
            currentUser: {},
            modelName: '',
            schemaName: '',
            catalogName: '',
            isGeneratedForRegistry: false,
            includeSources: false
        }
    },
    methods: {
        loadBusinessModel() {
            this.model = this.businessModel
            this.modelName = this.businessModel.name
        },
        loadUser() {
            this.currentUser = this.user
        },
        async loadModelInfo() {
            await this.$http.get(`/knowagemeta/restful-services/1.0/metaWeb/modelInfos/${this.businessModel.id}?user_id=${this.user.userUniqueIdentifier}`).then((response: AxiosResponse<any>) => {
                if (response.data.schemaName) {
                    this.schemaName = response.data.schemaName
                }
                if (response.data.catalogName) {
                    this.catalogName = response.data.catalogName
                }
            })
        },
        generateDatamart() {
            const url =
                `/knowagemeta/restful-services/1.0/metaWeb/buildModel/${this.businessModel.id}?user_id=${this.user.userId}` +
                `&model=${encodeURIComponent(this.modelName)}&schema=${this.schemaName}&catalog=${this.catalogName}&registry=${this.isGeneratedForRegistry}&includeSources=${this.includeSources}`
            this.$http.get(url).then(() => {
                this.$store.commit('setInfo', {
                    title: this.$t('common.toast.createTitle'),
                    msg: this.$t('common.toast.success')
                })
                this.$emit('generated')
            })
        },
        closeTemplate() {
            this.$emit('close')
        }
    }
})
